<div class="card m-0 bg-transparent">
  <div class="card-body">
    <andypf-json-viewer
      *ngIf="showJsonField"
      indent="2"
      expanded="2"
      theme="classic-dark"
      show-data-types="false"
      show-toolbar="true"
      expand-icon-type="square"
      show-copy="true"
      show-size="false"
      data="{{ formattedJson }}"
    >
    </andypf-json-viewer>
  </div>
</div>
